export default __webpack_public_path__ + "static/media/episode1VideoBg.4f0a7abd.jpg";